import HelpOutlineOutlinedIcon from "@mui/icons-material/HelpOutlineOutlined";
import AppModal from "../../Common/AppModal";

const ContinueOrCancel = ({
  title,
  paragraph,
  modal,
  toggle,
  onClickCallBack,
}) => {
  return (
    <AppModal
      open={modal}
      onClose={toggle}
      title={title}
      icon={<HelpOutlineOutlinedIcon />}
      headerAccent="indigo"
      size="sm"
      submitLabel="Continue"
      submitColor="success"
      onSubmit={onClickCallBack}
    >
      <div className={"d-flex justify-content-center p-2"}>{paragraph}</div>
    </AppModal>
  );
};

export default ContinueOrCancel;
